import { MatDialogRef } from '@angular/material/dialog';
import { EngagementErrorDialogDataModel } from './engagement-error-dialog-data.model';
import { ROUTE_TOKEN_ENGAGEMENTS_BASE, ROUTE_TOKEN_MAIN_BASE } from '../../../../routing-constants';

export class EngagementNavigationErrorStrategyModel implements EngagementErrorDialogDataModel {
  engagementId: number;
  errorCode?: string;
  shouldShowSupportLink: boolean;

  constructor(engagementId: number, errorCode?: string) {
    this.engagementId = engagementId;
    this.errorCode = errorCode;
    this.shouldShowSupportLink = !!errorCode;
  }

  getTitle = () => 'An error has occurred.';
  getMessage = () => `
    Please go back and try again.
    If the problem persists contact support at <a href="mailto:support@aiwyn.ai">support@aiwyn.ai</a> and send us the error code shown below.
  `;
  getButtonText = () => 'Back to Engagements';
  getButtonIcon = () => 'arrow-left';
  getRoutePath = () => ROUTE_TOKEN_ENGAGEMENTS_BASE;

  onButtonClick(dialogRef: MatDialogRef<any>): void {
    dialogRef.close();
    window.location.href = `${ROUTE_TOKEN_MAIN_BASE}/${ROUTE_TOKEN_ENGAGEMENTS_BASE}`;
  }
}
